import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/back-mobile.png'


const _withScopeId = n => (_pushScopeId("data-v-9462fe68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: 30,
  height: 30,
  src: _imports_0,
  alt: "back"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { useRouter } from 'vue-router';
import { ActionTypes, useStore } from '../../state';
import { isMobile } from 'mobile-device-detect';


export default /*#__PURE__*/_defineComponent({
  __name: 'BackButton',
  setup(__props) {

const router = useRouter();
const store = useStore();

const onClick = async () => {
  await store.dispatch(ActionTypes.LOADED, false);
  await router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-link",
          onClick: onClick
        }, _hoisted_3))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn-link",
          onClick: onClick
        }, " Back to the Memphisverse "))
  ]))
}
}

})